import { OPERATIONS_BACKEND_URL } from '@/config'
import { runJsonGet, runJsonPost } from '@/backend-client'
import { transformKeysToCamelCase } from './utils/casing'
import { User } from './models/user-service-model'

export const fetchCurrentUser = async (): Promise<User> => {
  const result = await runJsonGet(`${OPERATIONS_BACKEND_URL}/accounts/users/me`)
  return transformKeysToCamelCase(result.data)
}

export const fetchUserHasOrcasAccess = async (): Promise<boolean> => {
  const result = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/ordering/user-has-orcas-access`
  )
  return result.data
}

export const hasAcceptedTermsConditions = async (): Promise<boolean> => {
  const result = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/ordering/queries/has-carrier-accepted-legal-agreements`
  )
  return result.data
}

export const saveTermsAndConditions = async (): Promise<void> => {
  await runJsonPost(
    `${OPERATIONS_BACKEND_URL}/ordering/commands/accept-carrier-legal-agreements`
  )
}
